import axios from "axios";
import { getApiConfig } from "./config.js";

export const APIGetStops = async (
  pageNumber,
  filters,
  setLoading,
  institutionId,
  searchTerm,
  totalPerPage = 10,
) => {
  setLoading(true);

  try {
    const apiConfig = getApiConfig();
    const result = await axios.get(`${apiConfig.baseURL}/stops`, {
      headers: apiConfig.headers,
      params: {
        page: pageNumber,
        totalPerPage,
        institutionId: institutionId,
        searchKey: searchTerm,
        ...filters,
      },
    });
    return result;
  } catch (error) {
    console.error("Error fetching stops:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APICreateStop = async (
  stopData,
  setLoading,
  institutionId,
  token,
) => {
  setLoading(true);
  const apiConfig = getApiConfig();
  try {
    const formattedData = {
      ...stopData,
      institutionId: institutionId,
    };

    const result = await axios.post(
      `${apiConfig.baseURL}/stop`,
      formattedData,
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      },
    );
    return result;
  } catch (error) {
    console.error("Error creating stop:", error);
    return error;
  }
};

export const APIUpdateStop = async (
  stopData,
  setLoading,
  institutionId,
  token,
) => {
  setLoading(true);
  const { _id, ...formattedData } = stopData;
  const apiConfig = getApiConfig();

  try {
    const result = await axios.patch(
      `${apiConfig.baseURL}/stop/${_id}`,
      { ...formattedData, institutionId },
      {
        headers: {
          ...apiConfig.headers,
          token: token,
          institutionId: institutionId,
        },
      },
    );
    return result;
  } catch (error) {
    console.error("Error updating stop:", error);
    return error;
  }
};

export const APIDeleteStops = async (
  stopIds,
  setLoading,
  institutionId,
  token,
) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.delete(`${apiConfig.baseURL}/stops`, {
      headers: {
        ...apiConfig.headers,
        token: token,
        institutionId: institutionId,
      },
      data: { stopIds: Array.isArray(stopIds) ? stopIds : [stopIds] },
    });
    return result;
  } catch (error) {
    console.error("Error deleting stop:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIGetStopAddress = async (lat, lon, setLoading) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.get(`${apiConfig.nominatimURL}/reverse`, {
      headers: apiConfig.nominatimHeaders,
      params: {
        lat: lat,
        lon: lon,
        zoom: 17,
        format: "jsonv2",
        addressdetails: 1,
      },
    });

    return result;
  } catch (error) {
    console.error("Error fetching address:", error);
    return error;
  } finally {
    setLoading(false);
  }
};

export const APIForwardGeocode = async (query, setLoading) => {
  setLoading(true);
  const apiConfig = getApiConfig();

  try {
    const result = await axios.get(`${apiConfig.nominatimURL}/search`, {
      headers: apiConfig.nominatimHeaders,
      params: {
        q: query,
        format: "jsonv2",
        limit: 5,
        addressdetails: 0,
        countrycodes: "my,tl",
      },
    });

    return result;
  } catch (error) {
    console.error("Error fetching location from query:", error);
    return error;
  } finally {
    setLoading(false);
  }
};
